<div class="container" aria-modal="true">
  <div mat-dialog-title class="dialog-title">
    <h1 mat-dialog-title class="delete-title">Send Back Report</h1>
    <button mat-icon-button aria-label="close dialog" mat-dialog-close class="delete-close">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
    <div class="title_light" [innerHtml]="userText"></div>
    <div class="alert-text">
      <mat-icon class="material-icons-outlined alerting-icon">error_outline</mat-icon>
      This action cannot be undone!
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions>
    <div class="button-row-always">
      <button class="usa-button usa-button--secondary" mat-dialog-close>Cancel</button>
      <button class="usa-button delete" (click)="revertReport()" style="width: 155px;">
        <fa-icon class="fa-sm" style="font-size: 18px ;color:white !important;vertical-align: -2px;margin-right: 13px;"
          [icon]="faArrowRotateLeft"></fa-icon> Send Back</button>
    </div>
  </div>
</div>